define('viewModels/dashboards/qualityAdminDashboard/CalibrationsWidget',[
    'lib/lodash4',
    'lib/knockout',
    'moment',
    'viewModels/ViewModel',
    'util/errorCallbackFactory',
    'services/authService',
    'services/loggingService',
    'services/qualityManagementService'
], function (_, ko, moment, ViewModel, errorCallbackFactory, authService, loggingService, qualityManagementService) {
    'use strict';

    var CALIBRATION_GRID_COLUMNS = [
        {
            label: 'qualityAdminDashboard.calibrations.createdDate',
            id: 'createdDate'
        },
        {
            label: 'qualityAdminDashboard.calibrations.evaluationFormName',
            id: 'evaluationFormName'
        },
        {
            label: 'qualityAdminDashboard.calibrations.evalCount',
            id: 'evalCount'
        },
        {
            label: 'qualityAdminDashboard.calibrations.openCount',
            id: 'openCount'
        },
        {
            label: 'qualityAdminDashboard.calibrations.averageScore',
            id: 'averageScore'
        },
        {
            label: 'qualityAdminDashboard.calibrations.highScore',
            id: 'highScore'
        },
        {
            label: 'qualityAdminDashboard.calibrations.lowScore',
            id: 'lowScore'
        },
        {
            label: 'qualityAdminDashboard.calibrations.scoreVariation',
            id: 'scoreVariation'
        }
    ];

    /**
     *  QualityAdmin Dashboard
     */
    var CalibrationsWidget = ViewModel.extend(function (dateRangeObservable) {
        var self = this;

        self.loading = ko.observable(false);
        self.activityDateRange = dateRangeObservable;
        self.gridOptions = ko.observable({
            pageCount: 1,
            pageNumber: 1,
            pageSize: 25
        });
        self.calibrationGrid = ko.observable();

        var buildCalibrationGridRow = function (calibration) {
            try {
                var evalFormName = calibration.evaluationForm ?
                                        calibration.evaluationForm.name :
                                        ko.i18n.renderString('qualityAdminDashboard.calibrations.unknownEvalForm');
                var openEvals = _.reject(calibration.evaluations, { status: 'FINISHED'});

                return {
                    calibrationId: calibration.id,
                    createdDate: ko.i18n.formatDate(calibration.createdDate, 'llll'),
                    evaluationFormName: evalFormName,
                    evalCount: calibration.evaluations.length.toString(),
                    openCount: openEvals.length.toString(),
                    averageScore: calibration.averageScore.toString(),
                    highScore: calibration.highScore.toString(),
                    lowScore: calibration.lowScore.toString(),
                    scoreVariation: (calibration.highScore - calibration.lowScore).toString(),
                    conversationId: calibration.conversation.id
                };
            } catch (error) {
                loggingService.error("Error loading calibration: " + error);
            }
        };

        self.refreshGrid = function (incomingOptions) {
            self.loading(true);
            var dates = self.activityDateRange()[0].split('/');
            var options = {};
            if (incomingOptions) {
                options.pageNumber = incomingOptions.pageNumber;
                options.pageSize = incomingOptions.pageSize;
            }
            if (dates){
                options.startTime = dates[0];
                options.endTime = dates[1];
            }
            options.calibratorId = authService.principalId();
            qualityManagementService.getCalibrations(options)
                .then(function (queryResponse) {
                    self.gridOptions({
                        pageCount: queryResponse.pageCount,
                        pageNumber: queryResponse.pageNumber,
                        pageSize: queryResponse.pageSize
                    });
                    var rows = _.compact(_.map(queryResponse.entities, buildCalibrationGridRow));
                    self.calibrationGrid().rows(rows);
                })
                .finally(function(){
                    self.loading(false);
                });
        };

        self.subscribe(self.activityDateRange, function () {
            self.calibrationGrid().rows([]);
            self.gridOptions().pageNumber = 1;
            self.refreshGrid(self.gridOptions());
        });

        self.calibrationGrid({
            columns: CALIBRATION_GRID_COLUMNS,
            rows: ko.observableArray([]),
            dataOptions: self.gridOptions,
            loading: self.loading,
            onDataOptionsChange: self.refreshGrid
        });
        self.refreshGrid(self.gridOptions());
    });

    return CalibrationsWidget;
});

